var isType = require('./is-type');

var isDate = function isDate(value) {
  return isType(value, 'Date');
};

module.exports = isDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-date.js
// module id = 111
// module chunks = 0 1 2